module.exports = __webpack_public_path__ + "img/homepage-quick-links-mitsu.9ca67a07.jpg";